import { Box, LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";

function ScrollProgressIndicator() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      // Calcular el porcentaje de scroll
      const totalScrollableHeight = documentHeight - windowHeight;
      const progress = (scrollTop / totalScrollableHeight) * 100;

      setScrollProgress(Math.min(progress, 100));
    };

    // Agregar event listener
    window.addEventListener("scroll", handleScroll);

    // Limpiar en unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={9999}
      sx={{ width: "100%" }}
      aria-label="Indicador de progreso de scroll"
      role="progressbar"
      aria-valuenow={Math.round(scrollProgress)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <LinearProgress
        variant="determinate"
        value={scrollProgress}
        sx={{
          height: 4,
          backgroundColor: "transparent",
          "& .MuiLinearProgress-bar": {
            transition: "transform 0.1s ease-out",
          },
        }}
      />
    </Box>
  );
}

export default ScrollProgressIndicator;
